export default function LabMark({ className = 'h-8 w-8' }: { className?: string }) {
  return (
    <svg viewBox="0 0 36 36" fill="none" className={className} aria-hidden="true">
      <path d="M5 29H31M10 29L23 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M18 29A8 8 0 0 0 14 22" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="29" cy="10" r="3" fill="currentColor" />
    </svg>
  )
}
